import { atom } from 'recoil';

export const chatInputState = atom({
  key: 'chatInputState',
  default: null
});

export const specialtyState = atom({
  key: 'specialtyState',
  default: null
});

export const intelligenceChatIdState = atom({
  key: 'intelligenceChatIdState',
  default: null
});

export const intelligenceChatMessageIdState = atom({
  key: 'intelligenceChatMessageIdState',
  default: null
});

export const promptListState = atom({
  key: 'promptListState',
  default: []
});

export const activePromptConversationsState = atom({
  key: 'activePromptConversationsState',
  default: []
});

export const myScribeAILoadingState = atom({
  key: 'myScribeAILoadingState',
  default: false
});

export const myScribeAcknowledged = atom({
  key: 'myScribeAcknowledged',
  default: false
});

export const myScribeAutoMapSelectedNoteTypeState = atom({
  key: 'myScribeAutoMapSelectedNoteTypeState',
  default: null
});

export const myScribeAutoMapActivePromptIdState = atom({
  key: 'myScribeAutoMapActivePromptIdState',
  default: null
});

export const isAIGeneratingState = atom({
  key: 'isAIGeneratingState',
  default: false
});

export const enhanceNoteLoadingState = atom({
  key: 'enhanceNoteLoadingState',
  default: []
});

export const editedMessageIdsState = atom({
  key: 'editedMessageIdsState',
  default: new Set()
});

export const editedChatIdState = atom({
  key: 'editedChatIdState',
  default: null
});
